import { render, staticRenderFns } from "./Liste_Cours.vue?vue&type=template&id=20839b28&scoped=true&"
import script from "./Liste_Cours.vue?vue&type=script&lang=js&"
export * from "./Liste_Cours.vue?vue&type=script&lang=js&"
import style0 from "./Liste_Cours.vue?vue&type=style&index=0&id=20839b28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20839b28",
  null
  
)

export default component.exports